import { Recurso, UseCaseRecursoAsync } from "lib.common/dist/CleanArch";
import { ProductoDetalleDsKey } from "../entities/ProductoTiendaDsKey";
import { DeleteProductoDetalleParams } from "../../utils/params/ProductoDetalleParams";
import { GestionarProductoDetalleRepository } from "../repositories/GestionarProductoDetalleRepository";
import { ErrDevGenerico } from "lib.common/dist/errorHandler";

export class DeleteProductoDetalleUseCase<
    T_OUT extends ProductoDetalleDsKey
> extends UseCaseRecursoAsync<DeleteProductoDetalleParams, T_OUT> {
    private repository: GestionarProductoDetalleRepository<T_OUT>;
    constructor(repository: GestionarProductoDetalleRepository<T_OUT>) {
        super();
        this.repository = repository;
    }

    async call(
        input: DeleteProductoDetalleParams
    ): Promise<Recurso<T_OUT>> {
        try {
            return await this.repository.deleteProductoDetalle(input);
        } catch (error) {
            const errorCapa = new ErrDevGenerico(error as Error);
            return Recurso.fromError<T_OUT>(errorCapa);
        }
    }
}